import React from "react";
import ReactWOW from "react-wow";

const Theme = props => {
  const msg = props.Message;
  return (
    <section
      id="categories"
      style={{ backgroundImage: "Url(images/section-background-03.png)" }}
    >
      <div className="container">
        <div className="section-title">
          <h2>{msg.categories}</h2>
        </div>
        <div className="flex-box">
          {msg.categoriesData.map(it => {
            return (
              <ReactWOW animation="fadeInUp" delay="0.1s">
                <div className="box box-3">
                  <img src={it.image} alt="" className="img-fluid" />
                  <div className="content">
                    <h3>
                      {it.title.map(it => {
                        return [it, <br />];
                      })}
                    </h3>
                    {it.list.map(t => {
                      return <p key={t}>{t}</p>;
                    })}
                  </div>
                </div>
              </ReactWOW>
            );
          })}
          {/* <ReactWOW animation="fadeInUp" delay="0.1s">
            <div className="box box-3">
              <img src="images/theme-01.png" alt="" className="img-fluid" />
              <div className="content">
                <h3>Pre-Tertiary</h3>
                <p>
                  For students in junior colleges or polytechnics. International
                  students on exchange are welcome.
                </p>
              </div>
            </div>
          </ReactWOW>
          <ReactWOW animation="fadeInUp" delay="0.2s">
            <div className="box box-3">
              <img src="images/theme-02.png" alt="" className="img-fluid" />
              <div className="content">
                <h3>Undergraduates</h3>
                <p>
                  For students pursuing a Bachelor’s Degree. International
                  students on exchange are welcome.
                </p>
              </div>
            </div>
          </ReactWOW>
          <ReactWOW animation="fadeInUp" delay="0.3s">
            <div className="box box-3">
              <img src="images/theme-03.png" alt="" className="img-fluid" />
              <div className="content">
                <h3>Open</h3>
                <p>
                  For anyone in Singapore with an interest or passion for
                  coding.
                </p>
              </div>
            </div>
          </ReactWOW> */}
        </div>
      </div>
    </section>
  );
};

export default Theme;
